import { render } from "./Ports.vue?vue&type=template&id=3723c288"
import script from "./Ports.vue?vue&type=script&lang=js"
export * from "./Ports.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__